import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  private http = inject(HttpClient);

  get(): Observable<any[]> {
    return this.http.get<any[]>(Global.url + 'V1/status-ref');
  }

  create(data: any): Observable<any> {
    return this.http.post(Global.url + 'V1/status-ref', data);
  }

  update(id: number | string, data: any): Observable<any> {
    return this.http.put(Global.url + 'V1/status-ref/' + id, data);
  }

  delete(id: number | string): Observable<any> {
    return this.http.delete(Global.url + 'V1/status-ref/' + id);
  }
}
